import { ILink } from '@models/ILink';
import updateDataLayer from '@utils/helpers/gtm';
import useIsInIFrame from '@utils/hooks/useIsInIFrame';

interface Props {
  readonly links: ILink[];
  readonly title: string;
}

const LinksList = ({ links, title }: Props) => {
  const isInIFrame = useIsInIFrame();

  const handleLinkClick = (link: ILink, linkTitle: string) => {
    updateDataLayer({
      event: 'menuUsed',
      content_type: 'footer_menu',
      main_category: linkTitle,
      sub_category: link.name,
    });
  };

  return (
    <ul className="mb-10 xl:mb-0">
      {links?.map((link) => (
        <li className="ml-5 mt-5 md:ml-0" key={`list-${link.name}`}>
          <a
            className="body-two link-underline text-white"
            href={link.url}
            onClick={() => handleLinkClick(link, title)}
            target={isInIFrame ? '_parent' : link.target}
            data-testid="CT-02-Footer-Links-List-Link"
            aria-label={link.name}
          >
            <span dangerouslySetInnerHTML={{ __html: `${link.name}` }} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default LinksList;
